module.exports = __webpack_public_path__ + "static/media/05.8763078e.jpg";